export default file => () =>
    import('@/pages/' + file + '/index.vue')